import { render, staticRenderFns } from "./examinationManage.vue?vue&type=template&id=38764f6a&"
import script from "./examinationManage.vue?vue&type=script&lang=js&"
export * from "./examinationManage.vue?vue&type=script&lang=js&"
import style0 from "./examinationManage.vue?vue&type=style&index=0&id=38764f6a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports